<template slot-scope="{ isActive }">
  <div class="room-upgrade-modal-wrapper">
    <div
      class="room-upgrade-modal-image"
      :style="[
        {
          'background-image': `url(${previousRoomUpgradeImage}?wid=1280&hei=659&fmt=jpeg&op_usm=1,1,5,0&resMode=sharp2&fit=crop&qlt=75,0)`,
        },
      ]"
    >
      <span
        class="room-upgrade-modal-image-price-tag"
      >{{ tc('booking.onlyMorePerNight', { price: formatPrice(roomUpgradePriceDifference)}) }}</span>
      <div class="room-upgrade-modal-image-content">
        <div class="room-upgrade-modal-image-title">
          {{ tc('booking.upgradeYourRoom') }}
        </div>
      </div>
    </div>
    <div
      ref="modalContent"
      class="room-upgrade-modal-content"
    >
      <div class="comparison-card">
        <div class="comparison-card-title comparison-card-title--light">
          {{ roomUpgradeSelected ? tc('booking.yourOriginalSelection') : tc('booking.yourRoom') }}
        </div>
        <div class="comparison-card-room-name">
          {{ currentRoomName }}
        </div>
        <div
          class="comparison-card-room-description"
          v-html="currentRoomDescription"
        />
      </div>
      <div class="comparison-card">
        <div class="comparison-card-title comparison-card-title--red">
          {{ tc('booking.upgradeYourRoom') }}
        </div>
        <div class="comparison-card-room-name">
          {{ upgradeRoomName }}
        </div>
        <div
          class="comparison-card-room-description"
          v-html="upgradeRoomDescription"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'RoomUpgradeModalBody',
    computed: {
      ...mapState('cart', ['cart', 'roomUpgradeSelected', 'roomUpgradeTitle', 'roomUpgradePriceDifference', 'previousCartItem', 'previousRoomUpgradeInfo', 'previousRoomUpgradeImage']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('cart', ['itemsInCart', 'getRoomUpgradeAvailable', 'getRoomUpgradeAvailableInfo', 'getRoomUpgradesOptions']),
      ...mapGetters('currency', ['getDisplayPrice']),

      currentRoom() {
        return this.itemsInCart[0]
      },
      currentRoomName() {
        return this.roomUpgradeSelected ? this.previousCartItem?.sitecoreContent?.room?.title : this.currentRoom?.sitecoreContent?.room?.title
      },
      currentRoomDescription() {
        return this.previousRoomUpgradeInfo?.currentRoomDescription
      },
      upgradeRoomName() {
        return this.roomUpgradeTitle
      },
      upgradeRoomDescription() {
        return this.previousRoomUpgradeInfo?.roomUpgradeDescription
      }
    },
    methods: {
      formatPrice(price) {
        return this.getDisplayPrice({ price, withIsoCode: true, isoAfter: true })
      },
    }
  }
</script>
